import { c as _c } from "react/compiler-runtime";
import { isURLWithProtocol } from '@onefootprint/core';
import { Form } from '@onefootprint/ui';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import type { FormData, StepProps } from '@/pages/developers/vault-proxy/pages/list/vault-proxy.types';
const BasicConfiguration = t0 => {
  const $ = _c(78);
  const {
    id,
    onSubmit,
    values
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "create.form.basicConfiguration"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("vault-proxy", t1);
  let t2;
  if ($[1] !== values.accessReason || $[2] !== values.method || $[3] !== values.name || $[4] !== values.url) {
    t2 = {
      defaultValues: {
        name: values.name,
        accessReason: values.accessReason,
        method: values.method,
        url: values.url
      }
    };
    $[1] = values.accessReason;
    $[2] = values.method;
    $[3] = values.name;
    $[4] = values.url;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const form = useForm(t2);
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [{
      label: "GET",
      value: "GET"
    }, {
      label: "POST",
      value: "POST"
    }, {
      label: "PUT",
      value: "PUT"
    }, {
      label: "DELETE",
      value: "DELETE"
    }, {
      label: "PATCH",
      value: "PATCH"
    }];
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const methodOptions = t3;
  let t4;
  if ($[7] !== form || $[8] !== onSubmit) {
    t4 = form.handleSubmit(onSubmit);
    $[7] = form;
    $[8] = onSubmit;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t) {
    t5 = t(_temp);
    $[10] = t;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t5) {
    t6 = <h2 className="text-label-2 text-primary mb-4">{t5}</h2>;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t) {
    t7 = t(_temp2);
    $[14] = t;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t) {
    t8 = t(_temp3);
    $[16] = t;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t) {
    t9 = t(_temp4);
    $[18] = t;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t9) {
    t10 = {
      required: t9
    };
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10 || $[23] !== t7 || $[24] !== t8) {
    t11 = <Form.Input size="compact" name="name" label={t7} placeholder={t8} rules={t10} />;
    $[22] = t10;
    $[23] = t7;
    $[24] = t8;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== t) {
    t12 = t(_temp5);
    $[26] = t;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== t) {
    t13 = t(_temp6);
    $[28] = t;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== t) {
    t14 = t(_temp7);
    $[30] = t;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== t) {
    t15 = value => {
      if (!isURLWithProtocol(value)) {
        return t(_temp8);
      }
      return true;
    };
    $[32] = t;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== t14 || $[35] !== t15) {
    t16 = {
      required: t14,
      validate: t15
    };
    $[34] = t14;
    $[35] = t15;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] !== t12 || $[38] !== t13 || $[39] !== t16) {
    t17 = <Form.Input size="compact" id="url" name="url" label={t12} placeholder={t13} rules={t16} />;
    $[37] = t12;
    $[38] = t13;
    $[39] = t16;
    $[40] = t17;
  } else {
    t17 = $[40];
  }
  let t18;
  if ($[41] !== t) {
    t18 = t(_temp9);
    $[41] = t;
    $[42] = t18;
  } else {
    t18 = $[42];
  }
  let t19;
  if ($[43] !== t) {
    t19 = t(_temp10);
    $[43] = t;
    $[44] = t19;
  } else {
    t19 = $[44];
  }
  let t20;
  if ($[45] !== t) {
    t20 = t(_temp11);
    $[45] = t;
    $[46] = t20;
  } else {
    t20 = $[46];
  }
  let t21;
  if ($[47] !== t20) {
    t21 = {
      required: t20
    };
    $[47] = t20;
    $[48] = t21;
  } else {
    t21 = $[48];
  }
  let t22;
  if ($[49] !== t18 || $[50] !== t19 || $[51] !== t21) {
    t22 = <Form.Select size="compact" name="method" label={t18} placeholder={t19} rules={t21} options={methodOptions} />;
    $[49] = t18;
    $[50] = t19;
    $[51] = t21;
    $[52] = t22;
  } else {
    t22 = $[52];
  }
  let t23;
  if ($[53] !== t) {
    t23 = t(_temp12);
    $[53] = t;
    $[54] = t23;
  } else {
    t23 = $[54];
  }
  let t24;
  if ($[55] !== t) {
    t24 = t(_temp13);
    $[55] = t;
    $[56] = t24;
  } else {
    t24 = $[56];
  }
  let t25;
  if ($[57] !== t) {
    t25 = t(_temp14);
    $[57] = t;
    $[58] = t25;
  } else {
    t25 = $[58];
  }
  let t26;
  if ($[59] !== t25) {
    t26 = {
      required: t25
    };
    $[59] = t25;
    $[60] = t26;
  } else {
    t26 = $[60];
  }
  let t27;
  if ($[61] !== t23 || $[62] !== t24 || $[63] !== t26) {
    t27 = <Form.Input size="compact" id="accessReason" name="accessReason" label={t23} placeholder={t24} rules={t26} />;
    $[61] = t23;
    $[62] = t24;
    $[63] = t26;
    $[64] = t27;
  } else {
    t27 = $[64];
  }
  let t28;
  if ($[65] !== t11 || $[66] !== t17 || $[67] !== t22 || $[68] !== t27) {
    t28 = <div className="flex flex-col gap-6">{t11}{t17}{t22}{t27}</div>;
    $[65] = t11;
    $[66] = t17;
    $[67] = t22;
    $[68] = t27;
    $[69] = t28;
  } else {
    t28 = $[69];
  }
  let t29;
  if ($[70] !== id || $[71] !== t28 || $[72] !== t4 || $[73] !== t6) {
    t29 = <form id={id} onSubmit={t4}>{t6}{t28}</form>;
    $[70] = id;
    $[71] = t28;
    $[72] = t4;
    $[73] = t6;
    $[74] = t29;
  } else {
    t29 = $[74];
  }
  let t30;
  if ($[75] !== form || $[76] !== t29) {
    t30 = <FormProvider {...form}>{t29}</FormProvider>;
    $[75] = form;
    $[76] = t29;
    $[77] = t30;
  } else {
    t30 = $[77];
  }
  return t30;
};
export default BasicConfiguration;
function _temp($) {
  return $.title;
}
function _temp2($_0) {
  return $_0.name.label;
}
function _temp3($_1) {
  return $_1.name.placeholder;
}
function _temp4($_2) {
  return $_2.name.errors.required;
}
function _temp5($_3) {
  return $_3.url.label;
}
function _temp6($_4) {
  return $_4.url.placeholder;
}
function _temp7($_5) {
  return $_5.url.errors.required;
}
function _temp8($_6) {
  return $_6.url.errors.invalid;
}
function _temp9($_7) {
  return $_7.method.label;
}
function _temp10($_8) {
  return $_8.method.placeholder;
}
function _temp11($_9) {
  return $_9.method.errors.required;
}
function _temp12($_10) {
  return $_10.accessReason.label;
}
function _temp13($_11) {
  return $_11.accessReason.placeholder;
}
function _temp14($_12) {
  return $_12.accessReason.errors.required;
}